import { useCallback, useEffect } from 'react';
import { injectScript } from '#utils/inject-script/index.ts';
import type { TNps, TNpsOptions } from './useNps.types.ts';

const ZONKA_SCRIPT_URL = 'https://e-js.zonka.co';
const ZONKA_SCRIPT_ID = 'zfEmbedScript';

export const useNps = ({ isEnabled, workspaceId }: TNpsOptions): TNps => {
  const startSurvey = useCallback(
    (surveyId: string) => {
      if (!isEnabled) {
        return;
      }

      window._zf?.('startForm', surveyId);
    },
    [isEnabled],
  );

  useEffect(() => {
    if (!isEnabled || document.getElementById(ZONKA_SCRIPT_ID)) {
      return;
    }

    const encodedWorkspaceId = encodeURIComponent(workspaceId);

    window._zfQueue = window._zfQueue ?? [];

    window._zf = (...args) => {
      window._zfQueue?.push(args);
    };

    injectScript({
      id: ZONKA_SCRIPT_ID,
      src: `${ZONKA_SCRIPT_URL}/${encodedWorkspaceId}`,
    });
  }, [isEnabled, workspaceId]);

  return { startSurvey };
};
